import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GamingService } from '@app/services/gaming.service';
import { catchError, finalize } from 'rxjs/operators';
import { CandidateDetails } from './Interface';
import { commonComponents } from '@app/shared/common components/common components';
import * as feather from 'feather-icons';

@Component({
  standalone: false,
  selector: 'app-exclusion',
  templateUrl: './exclusion.component.html',
  styleUrls: ['./exclusion.component.css'],
})
export class ExclusionComponent implements OnInit {
  errorMessage: string;
  exclusionList: CandidateDetails[] = [];
  addUser = false;
  popUp = false;
  tableBody: any[] = [];
  tableHeader = commonComponents.exclusion.tableHeaders;
  inputField1 = commonComponents.exclusion.AddExclusion;
  inputfield2 = commonComponents.exclusion.editfields;
  sortDirection = 1;
  sortField = '';
  isLoading = false;
  confirmDelete = false;
  DeletePopup = false;
  selectedCandidate: any;
  currentPage = 1;
  popupTitle1 = '';
  popup1: boolean;
  popupTitle: string;
  editUser: boolean;
  editField: CandidateDetails;
  tosterMessage: { type?: string; message?: string } = { type: '', message: '' };
  selected: boolean;
  totalPageNo:number
  file: File | null = null;
  csvData: any[] = [];

  columns: { key: string, label: string, sortable?: boolean }[] = [
    { key: 'record_id', label: 'ID', sortable: true },
    { key: 'name', label: 'Name', sortable: true },
    { key: 'email', label: 'Email', sortable: true },
    { key: 'dob', label: 'DOB', sortable: true },
    { key: 'universal_player_id', label: 'Universal Player Id', sortable: false },
    { key: 'state', label: 'State', sortable: false },
    { key: 'actions', label: 'Actions' }
  ];

  constructor(private gamingService: GamingService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.gamingExclusionList(1);
    this.exclusionlistPage()
  }

  exclusionlistPage(){
    this.gamingService.gamingExclusionListCount()
      .pipe(
        catchError(() => {
          this.isLoading = !true;
          this.errorMessage = 'Failed to load Gaming Exclusion Count';
          return null;
        }),
        finalize(() => { }),)
      .subscribe((data: any) => {
        this.totalPageNo = Math.ceil(data.count / 20);
      });
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file && file.type === 'text/csv') {
      this.file = file;
      this.readCSVFile(file);
    } else {
      alert('Please upload a valid CSV file.');
    }
  }
  readCSVFile(_file: any) {
    throw new Error('Method not implemented.');
  }

  gamingExclusionList(pageNumber: any): void {
    this.isLoading = true;
    this.gamingService
      .gamingExclusionList(pageNumber)
      .pipe(
        catchError(() => {
          this.isLoading = !true;
          this.errorMessage = 'Failed to load Gaming Exclusion List';
          return null;
        }),
        finalize(() => {}),
      )
      .subscribe((data: any) => {
        if (data) {
          data = data.data.filter((i) => i.last_name !== null);
          this.exclusionList = data;
          this.listTable(data);
          this.isLoading = !true;
          this.onSearch('');
          this.listTable(data);
        }
      });
  }

  ngAfterViewInit() {
    feather.replace();
  }

  listTable(data: CandidateDetails[]) {
    this.tableBody = data.map((candidate) => ({
      record_id: candidate.record_id,
      name: `${candidate.first_name} ${candidate.last_name}`,
      email: this.formatEmail(candidate.email_addr_txt),
      dob: this.formatDate(candidate.dob),
      universal_player_id: candidate.universal_player_id,
      state: candidate.state,
      actions: ''
    }));
  }
  

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  formatEmail(email: string | null): string {
    if (!email) {
      return 'N/A';
    }
    const maxLength = 30;
    return email.length > maxLength ? email.substring(0, maxLength) + '...' : email;
  }

  onSearch(searchTerm: string): void {
    if (searchTerm) {
      const filterdata = this.exclusionList.filter(
        (i) =>
          (i.record_id && i.record_id.toString().includes(searchTerm)) ||
          (i.first_name && i.first_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (i.email_addr_txt && i.email_addr_txt.toLowerCase().includes(searchTerm.toLowerCase())),
      );
      this.listTable(filterdata);
    } else {
      this.listTable(this.exclusionList);
    }
  }

  openAddmember() {
    this.addUser = true;
    this.popUp = true;
    this.popupTitle = 'Add Candidate';
  }

  close() {
    this.addUser = !true;
    this.popUp = !true;
    this.DeletePopup = !true;
    this.confirmDelete = !true;
    this.editUser = !true;
    this.selectedCandidate = null;
    this.selected = false;
  }

  onInvestigate(candidate: any): void {
    const editField = this.exclusionList.find((i) => i.record_id === candidate.record_id);
    this.popUp = true;
    this.editUser = true;
    this.selected = false;
    this.popupTitle = 'Edit Candidate';
    this.editField = editField;
  }
  selectCandidate(row: any) {
    this.selectedCandidate = this.exclusionList.find((i) => i.record_id === row);
    // this.selectedCandidate = row;
    if (this.selectedCandidate) {
      this.popUp = true;
      this.addUser = false;
      this.DeletePopup=false
      this.editUser = false;
      this.selected = true;
      this.popupTitle = 'Candidate Details';
      const dateObj = new Date(this.selectedCandidate.dob);
      const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      const day = dateObj.getDate().toString().padStart(2, '0');
      const year = dateObj.getFullYear();
      this.selectedCandidate.dob = `${month}/${day}/${year}`;
    }
  }
  onUpdateParent(updatedData: any) {
    // Update the parent table with the new data
    const index = this.exclusionList.findIndex((item) => item.record_id === updatedData.record_id);
    if (index !== -1) {
      this.exclusionList[index] = updatedData;
    }
    this.gamingExclusionList(this.currentPage);

    this.popUp = false;
  }
  closePopup() {
    this.close()
  }
  onDelete(candidate: any): void {
    this.addUser = false;
    this.editUser = false;
    this.selected = false;
    this.selectedCandidate = candidate;
    if (this.confirmDelete === true) {
      this.gamingService.deleteExclusion(candidate.id).subscribe({
        next: () => {
          this.gamingExclusionList(this.currentPage);
          this.tosterMessage = {
            message: 'Deleted successfully.',
            type: 'success',
          };
          this.close();
        },
        error: (error) => {
          this.tosterMessage = {
            message: 'Deleted Failed.',
            type: 'failed',
          };
          console.error('Error deleting record:', error);
        },
      });
    } else {
      this.confirmDelete = true;
      this.selected = false;
      this.popupTitle = 'Confirm to Delete';
      this.popUp = true;
      this.DeletePopup = true;
    }
  }

  sortTable(field: string): void {
    if (this.sortField === field) {
      this.sortDirection *= -1;
    } else {
      this.sortField = field;
      this.sortDirection = 1;
    }
    this.tableBody.sort((a, b) => {
      const valueA = a[field] || '';
      const valueB = b[field] || '';

      return (valueA > valueB ? 1 : valueA < valueB ? -1 : 0) * this.sortDirection;
    });
  }
  
  addSuccess(data: any) {
    this.selected = false;
    this.editUser = false;
    this.addUser = true;
    if (data === 'success') {
      this.close();
      this.gamingExclusionList(this.currentPage);
    }
  }
  goToPage(page: number) {
      this.gamingExclusionList(page);
      this.currentPage = page
   
  }

  nextPage() {
    if (1 <= this.currentPage) {
      const page = this.currentPage +1
      this.gamingExclusionList(page);
      this.currentPage = page;
    }
  }

  prevPage() {
    if (this.currentPage ) {
      this.gamingExclusionList(this.currentPage--);
      this.currentPage--;
    }
  }

  goto5(){
    const page = this.totalPageNo
    this.gamingExclusionList(page);
    this.currentPage = page
  }

  // getTotalPages() {
  //   if (this.currentPage) {
  //     this.currentPage+5;
  //     this.gamingExclusionList(this.currentPage);
  //   }
  // }
}
